export default "__VITE_ASSET__CmbF5fW3__"